import { isUndefined } from '@aloft/toolkit-shared';

import { useContext } from 'react';

import { CheckoutStepsContext } from './CheckoutStepsContext.ts';

export const useCheckoutSteps = () => {
  const ctx = useContext(CheckoutStepsContext);
  if (isUndefined(ctx)) {
    throw new Error('useCheckoutSteps must be used within a CheckoutStepsProvider');
  }
  return ctx;
};
